import React, 
       { useState, 
         useContext, 
         useEffect }   from 'react';
import { Form, 
         Button, 
         Container, 
         Row, 
         Col         } from 'react-bootstrap';
import api             from './AxiosConfig';
import { AuthContext } from './AuthContext';
import moment          from 'moment-timezone';

export const timeZones = moment.tz.names();

function Profile() {
    const { getUserId,
            isAdmin,
            userType  }                   = useContext(AuthContext);
    const [message,      setMessage]      = useState('');
    const [messageError, setMessageError] = useState( false );
    const [formData,     setFormData]     = useState({});
    const [userId,       setUserId]       = useState( null );
    const daysOfWeek = [
        { name: 'Sunday',    code: 0 },
        { name: 'Monday',    code: 1 },
        { name: 'Tuesday',   code: 2 },
        { name: 'Wednesday', code: 3 },
        { name: 'Thursday',  code: 4 },
        { name: 'Friday',    code: 5 },
        { name: 'Saturday',  code: 6 },
        ];

    useEffect(() => {
        const fetchUserId = async () => {
            console.log("Profile: getUserId");
            const id = await getUserId();
            setUserId(id);
        };
        fetchUserId();
    }, [getUserId]);
       
    useEffect(() => {
        async function getProfile() {
            console.log("user = " + userId );
            if ( userId ) {
                try {
                    const response = await api.get(`/site/users/${encodeURIComponent(userId)}`, {withCredentials: true });
                    setMessage('');
                    setFormData({first_name:                response.data.first_name,
                                 last_name:                 response.data.last_name,
                                 reminder_enabled:          response.data.reminder_enabled,
                                 weekly_report_enabled:     response.data.weekly_report_enabled,
                                 start_of_week:             response.data.start_of_week,
                                 reminder_hour:             response.data.reminder_hour,
                                 time_zone:                 response.data.time_zone,
                                 DOB:                       response.data.DOB,
                                 days_till_90_enabled:      response.data.days_till_90_enabled,
                                 checklist_summary_enabled: response.data.checklist_summary_enabled,
                                 weekly_summary_enabled:    response.data.weekly_summary_enabled
                                 }); 
                } catch (error) {
                    console.log("get Profile: " + error);
                }
            }
        }
        // Fetch the detailed record for this goal.
        getProfile();
    }, [userId]);
    
    // Format date for date form control.
    const formatDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are zero-based
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    
    const handleChange = (e) => {
        const name = e.target.name;
        var   value = null;
        console.log("name=" + name);
        if (name === 'reminder_enabled' || name === 'weekly_report_enabled' || name === 'days_till_90_enabled' || name === 'checklist_summary_enabled' || name === 'weekly_summary_enabled' ){
             value = e.target.checked;
             console.log("Checkbox");
        } else {
             value = e.target.value;
             console.log("Value");
        }
        console.log("handleChange " + name + " = " + value);
        setFormData({ ...formData, [name]: value });
        console.log("formData = " + JSON.stringify(formData));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Update user profile logic here
        console.log("Profile updated:", formData);

        try {
           const response = await api.put(`/site/users/${encodeURIComponent(userId)}`, { userProfile: formData } , { withCredentials: true });
           setMessage(response.data.message);  // Display success message from server
           setMessageError( false );
        } catch (error) {
           if (error.response) {
              setMessage(error.response.data.message);  // Display error message from server
              setMessageError( true );
           } else {
              setMessage('An error occurred while updating.');
              setMessageError( true );
           }
        }
    };

    return (
        <Container className="mt-4">
                    <h2>Profile</h2>
                    <Form onSubmit={handleSubmit}>
    
                        <Form.Group as={Row} className="mb-3" controlId="formFirstName">
                            <Form.Label column xs={6} className="text-end">First Name</Form.Label>
                            <Col xs={6}>
                                <Form.Control
                                type="text"
                                name="first_name"
                                value={formData.first_name}
                                onChange={handleChange}
                                placeholder="Enter first name"
                            />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="formLastName">
                            <Form.Label column xs={6} className="text-end">Last Name</Form.Label>
                            <Col xs={6}>
                                <Form.Control
                                type="text"
                                name="last_name"
                                value={formData.last_name}
                                onChange={handleChange}
                                placeholder="Enter last name"
                            />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="formDOB">
                            <Form.Label column xs={6} className="text-end">Date of Birth</Form.Label>
                            <Col xs={6}><Form.Control type="date" name="DOB" value={formatDate(formData.DOB)} onChange={handleChange} placeholder="Date of Birth" /></Col>
                        </Form.Group>
                        
                        <Form.Group as={Row} className="mb-3" controlId="formDaysTill90Enabled">
                            <Form.Label column xs={6} className="text-end">Show Days Until 90</Form.Label>
                            <Col xs={6}><Form.Check name="days_till_90_enabled" type="checkbox" checked={formData.days_till_90_enabled} onChange={handleChange} /></Col>
                        </Form.Group>
                                    
                        <Form.Group as={Row} className="mb-3" controlId="formStartOfWeek">
                            <Form.Label column xs={6} className="text-end">Start of Week</Form.Label>
                            <Col xs={6}><Form.Control as="select" name="start_of_week" value={formData.start_of_week} onChange={handleChange}>
                                <option value="" disabled>
                                --Choose a day--
                                </option>
                                {daysOfWeek.map((day) => (<option key={day.code} value={day.code}>{day.name}</option>))}
                            </Form.Control></Col>                        
                        </Form.Group>
                                    
                        <Form.Group as={Row} className="mb-3" controlId="formWeeklyReoprtRequired">
                            <Form.Label column xs={6} className="text-end">Weekly Report Required</Form.Label>
                                <Col xs={6}><Form.Check name="weekly_report_enabled" type="checkbox" checked={formData.weekly_report_enabled} onChange={handleChange} /></Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="formReminderEnabled">
                            <Form.Label column xs={6} className="text-end">Send Reminders</Form.Label>
                            <Col xs={6}><Form.Check name="reminder_enabled" type="checkbox" checked={formData.reminder_enabled} onChange={handleChange} /></Col>
                        </Form.Group>
                                    
                        <Form.Group as={Row} className="mb-3" controlId="formReminderHour">
                           <Form.Label column xs={6} className="text-end">Reminder Hour (0-23)</Form.Label>
                           <Col xs={6}><Form.Control 
                               type="number"
                               name="reminder_hour"
                               min="0" 
                               max="23" 
                               value={formData.reminder_hour} 
                               onChange={handleChange} 
                               /></Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" >
                            <Form.Label column xs={6} className="text-end">Time Zone</Form.Label>
                            <Col xs={6}><select name="time_zone" value={formData.time_zone} onChange={handleChange} required style={{ maxWidth: '200px', width: '100%' }} >
                            {timeZones.map((tz) => (
                            <option key={tz} value={tz}>
                            {tz}
                            </option>
                            ))}
                            </select></Col>
                        </Form.Group>
                        
                        <Form.Group as={Row} className="mb-3" controlId="formChecklistSummaryEnabled">
                            <Form.Label column xs={6} className="text-end">Checklist Summary</Form.Label>
                            <Col xs={6}><Form.Check name="checklist_summary_enabled" type="checkbox" checked={formData.checklist_summary_enabled} onChange={handleChange} /></Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="formWeeklySummaryEnabled">
                            <Form.Label column xs={6} className="text-end">Weekly Summary</Form.Label>
                            <Col xs={6}><Form.Check name="weekly_summary_enabled" type="checkbox" checked={formData.weekly_summary_enabled} onChange={handleChange} /></Col>
                        </Form.Group>

                        {/* Submit Button */}
                        <Form.Group as={Row} className=" text-center mt-4">
                        <Col>
                        <Button variant="primary" type="submit">
                            Update Profile
                        </Button>
                        </Col>
                        </Form.Group>
                                    
                    </Form>
                    <Row><Col>User Type</Col><Col>{userType === 0 ? (<>Free User</> ) : (<>Premium User</>)}</Col></Row>
                    <Row><Col>Admin</Col><Col>{isAdmin === true ? (<>Yes</> ) : (<>No</>)}</Col></Row>
                    <Row><Col className={'text-center message-err-' + messageError }>{message}</Col></Row>
        </Container>
    );
}

export default Profile;
